<template>
  <div v-show="Auth" id="wrapper">
    <!-- Navigation -->
    <!-- <nav class="navbar navbar-default navbar-fixed-top" role="navigation" style="margin-bottom: 0" :style="{ backgroundImage: 'url(' + image + ')' }"> -->
    <nav class="navbar navbar-default navbar-fixed-top" role="navigation" style="margin-bottom: 0">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="index.html">شركة باور لايف</a>
      </div>
      <!-- /.navbar-header -->

      <ul class="nav navbar-top-links navbar-left">
        <li class="dropdown" id="notificationDropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#" style="position: relative;">
            <i class="fa fa-bell fa-fw"></i>
            <i class="fa fa-caret-down"></i>

            <!-- الدائرة الحمراء مع العدد -->
            <span v-if="unreadCount > 0"
                  class="badge"
                  style="position: absolute; top: 5px; right: 5px; background-color: red; color: white; border-radius: 50%; font-size: 10px; padding: 3px 6px;">
              {{ unreadCount }}
            </span>
          </a>

          <ul class="dropdown-menu dropdown-alerts">
            <li v-for="(notif, index) in notifications" :key="index">
              <a href="#" @click="getCustomerDelay(notif, index)">
                <div>
                   {{ notif.type + ' [' + notif.user + ' ]'}}
                  <span class="pull-right text-muted small">{{ notif.time }}</span>
                  <br> {{ notif.name }}
                </div>
              </a>
            </li>

            <li v-if="notifications.length > 0" class="divider"></li>

            <!-- <li>
              <a class="text-center" href="#">
                <strong>See All Alerts</strong>
                <i class="fa fa-angle-right"></i>
              </a>
            </li> -->
          </ul>
        </li>
        <li v-show="!built" class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <i class="fa fa-envelope fa-fw"></i> <i class="fa fa-caret-down"></i>
          </a>
          <ul class="dropdown-menu dropdown-messages">
            <li>
              <a href="#">
                <div>
                  <strong>John Smith</strong>
                  <span class="pull-right text-muted">
                    <em>Yesterday</em>
                  </span>
                </div>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <strong>John Smith</strong>
                  <span class="pull-right text-muted">
                    <em>Yesterday</em>
                  </span>
                </div>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <strong>John Smith</strong>
                  <span class="pull-right text-muted">
                    <em>Yesterday</em>
                  </span>
                </div>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="text-center" href="#">
                <strong>Read All Messages</strong>
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
          <!-- /.dropdown-messages -->
        </li>
        <!-- /.dropdown -->
        <li class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <i class="fa fa-tasks fa-fw"></i> <i class="fa fa-caret-down"></i>
          </a>
          <ul class="dropdown-menu dropdown-tasks">
            <li>
              <a href="#">
                <div>
                  <p>
                    <strong>اقساط محصلة: </strong>
                    {{Remainder_p}} % باقى [{{Remainder}}]
                  </p>
                  <div class="progress progress-striped active">
                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: Remainder_p + '%'}">
                      <span class="sr-only">{{Remainder_p}}% </span>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <p>
                    <strong>طلبات صيانة منجزة: </strong>
                    {{MaintenanceReq_p}} % باقى [{{MaintenanceReq}}]
                  </p>
                  <div class="progress progress-striped active">
                    <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: MaintenanceReq_p + '%'}">
                      <span class="sr-only">{{MaintenanceReq_p}}% </span>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <p>
                    <strong>صيانة دورية منجزة: </strong>
                    {{Maintenance_p}} % باقى [{{Maintenance}}]
                  </p>
                  <div class="progress progress-striped active">
                    <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: Maintenance_p + '%'}">
                      <span class="sr-only">{{Maintenance_p}}% </span>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <!-- /.dropdown-tasks -->
        </li>
        <!-- /.dropdown -->
        <li v-show="!built" class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <i class="fa fa-bell fa-fw"></i> <i class="fa fa-caret-down"></i>
          </a>
          <ul class="dropdown-menu dropdown-alerts">
            <li>
              <a href="#">
                <div>
                  <i class="fa fa-comment fa-fw"></i> New Comment
                  <span class="pull-right text-muted small">4 minutes ago</span>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <i class="fa fa-twitter fa-fw"></i> 3 New Followers
                  <span class="pull-right text-muted small">12 minutes ago</span>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <i class="fa fa-envelope fa-fw"></i> Message Sent
                  <span class="pull-right text-muted small">4 minutes ago</span>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <i class="fa fa-tasks fa-fw"></i> New Task
                  <span class="pull-right text-muted small">4 minutes ago</span>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#">
                <div>
                  <i class="fa fa-upload fa-fw"></i> Server Rebooted
                  <span class="pull-right text-muted small">4 minutes ago</span>
                </div>
              </a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="text-center" href="#">
                <strong>See All Alerts</strong>
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
          <!-- /.dropdown-alerts -->
        </li>
        <!-- /.dropdown -->
        <li class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <img :src="imgURL" v-bind:alt="pic" class="avatar">
            {{main_data[0].value}}  <i class="fa fa-caret-down"></i>
          </a>
          <ul class="dropdown-menu dropdown-user">
            <li v-show="$per.value.getUserProfileInfo"><router-link to="/changeprofile"><i class="fa fa-user fa-fw"></i>عرض الملف الشخصى</router-link>
            </li>
            <li  v-show="$per.value.changePassword"><router-link to="/changepassword"><i class="fa fa-user fa-fw"></i>تغيير كلمة المرور</router-link>
            </li>
            <li><router-link to="/userCallLog"><i class="fa fa-phone fa-fw"></i>سجل المكالمات</router-link>
            </li>
            <li><router-link to="/userpayrolldetails"><i class="fa fa-phone fa-fw"></i>عمليات الشهر</router-link>
            </li>
            <li class="divider"></li>
            <li><router-link to="/Login"><img :src="QrCodeImage" style="width:100%;height:100%;"/></router-link>
            </li>
            <li class="divider"></li>
            <li><a href="#" @click.prevent="preformLogout"><i class="fa fa-sign-out fa-fw"></i> خروج</a>
            </li>
          </ul>
          <!-- /.dropdown-user -->
        </li>
        <!-- /.dropdown -->
      </ul>
      <!-- /.navbar-top-links -->
      <!-- navbar-top-First Start -->
      <div class="navbar-default sidebar "   role="navigation">
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
            <li>
              <div class="col-lg-4 col-md-4 col-sm-4"  style="padding: 0px;">
                <router-link to="/changeprofile"><img :src="imgURL" v-bind:alt="pic" class="avatarLarg" style="margin: 8px 10px 8px 8px"></router-link>

              </div>
              <div class="col-lg-8 col-md-8 col-sm-8" style="padding-top: 15px; padding-right: 5px;">
                <h6 style="color:green">&nbsp; فرع: {{main_data[1].value}}</h6>
                <h6 style="color:green">&nbsp;{{main_data[2].value}}</h6>
              </div>
              <div style="margin: 0px 30px 0px 0px ">
                <h5><small style="color:red">app version: {{appVersion}}</small></h5>
              </div>
              <!-- /input-group -->
            </li>
            <li   style="padding:10px;text-align: center">
              <h4>[القائمة الرئيسية]</h4>
            </li>
            <li   style="padding:10px;text-align: center">
            </li>
            </ul>
        </div>
      </div>
      <!-- navbar-top-First End -->
      <!-- <div class="navbar-default sidebar sidebarcustom" style="overflow-y: scroll; top: 100px;bottom: 0;position: fixed; " role="navigation" :style="{ backgroundImage: 'url(' + imageSidebar + ')' }"> -->
        <div class="navbar-default sidebar sidebarcustom" style="overflow-y: scroll; top: 100px;bottom: 0;position: fixed; " role="navigation">

  <!-- <div class="navbar-default sidebar" role="navigation"> -->
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
            <!-- /Tbaark System Menu Start -->
            <!-- /Tbaark System Menu Start -->
            <li>
              <router-link to="/dashborad"  > <i class="fa fa-dashboard fa-fw"></i> الصفحة الرئيسية </router-link>
            </li>
            <li v-show="this.$per.value.company_department_show">
              <a href="#" @click="changeMenu(1)"><i class="fa fa-building" ></i> إدارة الشركة <span class="fa arrow"></span></a>
              <ul class=" nav nav-second-level collapse " :class="isMenu01 ? 'in' : ''" >
                <li v-show="this.$per.value.getCompanyInfo">
                  <router-link to="/cominfo"> بيانات الشركة </router-link>
                </li>
                <li v-show="this.$per.value.getBranche">
                  <router-link to="/branches"> بيانات الفروع </router-link>
                </li>
                <li v-show="this.$per.value.getItem">
                  <router-link to="/items">الأصناف</router-link>
                </li>
                <li v-show="this.$per.value.getRevenueExpenseTypes">
                  <router-link to="/expensetypes">أنواع الايرادات والمصروفات</router-link>
                </li>
                <li v-show="this.$per.value.getJob">
                  <router-link to="/jobs"> الوظائف </router-link>
                </li>
                <li v-show="this.$per.value.getGovernorates">
                  <router-link to="/governorates"> المحافظات </router-link>
                </li>
                <li v-show="this.$per.value.getCity">
                  <router-link to="/cities"> المدن والمراكز </router-link>
                </li>
                <li v-show="this.$per.value.getCity">
                  <router-link to="/manufacturingcomponents"> مكونات التصنيع </router-link>
                </li>
                <li v-show="this.$per.value.getCity">
                  <router-link to="/assets"> الأصول </router-link>
                </li>
                <li v-show="this.$per.value.permissions_show">
                  <a href="#" @click="changeMenu(0)"> الصلاحيات <span class="fa arrow"></span></a>
                  <ul class="nav nav-third-level collapse " :class="isMenu00 ? 'in' : ''" >
                    <li v-show="this.$per.value.getDepartment">
                      <router-link to="/departments"> الإدارات </router-link>
                    </li>
                    <li v-show="this.isdba == 0">
                      <router-link to="/permissionitems"> بنود الصلاحيات </router-link>
                    </li>
                    <li v-show="this.$per.value.getUserGroup">
                      <router-link to="/usergroups"> بيانات المجموعات </router-link>
                    </li>
                    <li v-show="this.$per.value.rolePermission_show">
                      <router-link to="/permissions"> صلاحيات المجموعات </router-link>
                    </li>
                  </ul>
                  <!-- /.nav-third-level -->
                </li>
                <li v-show="this.$per.value.getCity">
                  <router-link to="/support"> الدعم الفنى </router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.Branch_department_show">
              <a href="#" @click="changeMenu(2)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة الفرع <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu02 ? 'in' : ''" >
                <li v-show="this.$per.value.getBranch">
                  <router-link to="/branch"> بيانات الفرع </router-link>
                </li>
                <li v-show="this.$per.value.getItineraries">
                  <router-link to="/lines">الخطوط</router-link>
                </li>
                <li v-show="this.$per.value.getRegions">
                  <router-link to="/regions">المناطق</router-link>
                </li>
                <li v-show="this.$per.value.getRegions">
                  <router-link to="/villages">القرى</router-link>
                </li>
                <li v-show="this.$per.value.getMaintenanceItem">
                  <router-link to="/itemprices">أسعار الأصناف</router-link>
                </li>
                <li v-show="this.$per.value.getMaintenanceItem">
                  <router-link to="/maintenancegroups">مجموعات فترات التغيير</router-link>
                </li>
                <li v-show="this.$per.value.getMaintenanceItem">
                  <router-link to="/maintenanceItem">فترة التغيير</router-link>
                </li>
                <li v-show="this.$per.value.getCity">
                  <router-link to="/offers">العروض وعقود الصيانة</router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.purchase_department_show">
              <a href="#" @click="changeMenu(3)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة المشتريات <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu03 ? 'in' : ''" >
                <li>
                  <router-link to="/vendors">الموردين</router-link>
                </li>
                <li>
                  <router-link to="/postdeliveryticket">ترحيل إذون استلام</router-link>
                </li>
                <li>
                  <router-link to="/vendorsmovements">حركة الموردين</router-link>
                </li>
                <li>
                  <router-link to="/postreturnpurchasetickets">ترحيل إذن رد بضاعة</router-link>
                </li>
                <li>
                  <router-link to="/postransferbranch">تحويل بضاعة لفرع آخر</router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.sales_department_show">
              <a href="#" @click="changeMenu(4)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة المبيعات و العملاء <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu04 ? 'in' : ''" >
                <!-- <li v-show="this.$per.value.getCustomer">
                  <router-link to="/new-customers">بيانات العملاء</router-link>
                </li>
                <li>
                  <router-link to="/create-invoice">إصدار إيصالات أقساط</router-link>
                </li>
                <li>
                  <router-link to="/Offer-deals">تعاقدات العروض</router-link>
                </li>
                <li>
                  <router-link to="/distribution">توزيع</router-link>
                </li>
                <li>
                  <router-link to="/invoices">إيصالات موبايل</router-link>
                </li>
                <li>
                  ----------------------------------------------
                </li> -->
                <li v-show="this.$per.value.getCustomer">
                  <router-link to="/customers">بيانات العملاء </router-link>
                </li>
                <li>
                  <router-link to="/installmentsarrears">تقرير بالاقساط المتأخرة</router-link>
                </li>
                <li>
                  <router-link to="/maintenancearrears">تقرير بالصيانات المتأخرة</router-link>
                </li>
                <li>
                  <router-link to="/offers-installments-arrears">تقرير باقساط العروض المتأخرة</router-link>
                </li>
                <li>
                  <router-link to="/lastmaintenance">تقرير بآخر الصيانات</router-link>
                </li>
                <li>
                  <router-link to="/withoutoffers"> عملاء بدون عروض </router-link>
                </li>
                <li>
                  <router-link to="/directsales">المبيعات المباشرة</router-link>
                </li>
                <li v-show="this.$per.value.getCustomer">
                  <router-link to="/new-customers">
                    <i class="fa fa-cog fa-spin" style="color:red"></i>
                    بيانات العملاء <span style="color:red"> <b>جديد</b> </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.sales_department_show">
              <a href="#" @click="changeMenu(10)"><i class="fa fa-bar-chart-o fa-fw"></i> حوافظ وإيصالات <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu10 ? 'in' : ''" >
                <li>
                  <router-link to="/createreceipts">إصدار ايصالات</router-link>
                </li>
                <li>
                  <router-link to="/createfolders">إنشاء حوافظ</router-link>
                </li>
                <li>
                  <router-link to="/createmaintenancestatement">حوافظ الايصالات</router-link>
                </li>
                <li>
                  <router-link to="/settlementcollectorsaccounts">تسوية الحوافظ</router-link>
                </li>
                <li>
                  <a @click="SearchAlterReceipt()" href="#SearchAlterReceipt" role="button" data-toggle="modal">بحث وتعديل ايصال</a>
                </li>                <li>
                  <router-link to="/receiptauthorization">مصادقة ايصالات</router-link>
                </li>
                <li>
                  <router-link to="/dailyaccounts1">اليومية</router-link>
                </li>
                <li>
                  <router-link to="/dailyreview">مراجعة اليومية</router-link>
                </li>
                <li>
                  <router-link to="/dailyreview1">مراجعة اليومية1</router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.store_department_show">
              <a href="#" @click="changeMenu(5)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة المخازن <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu05 ? 'in' : ''" >
                <li>
                  <router-link to="/stores">المخازن</router-link>
                </li>
                <li>
                  <router-link to="/firstbalance">أرصدة بداية الفترة</router-link>
                </li>
                <li>
                  <router-link to="/deliveryticket">إذن استلام بضاعة</router-link>
                </li>
                <li>
                  <router-link to="/teturnpurchasetickets">إذن رد بضاعة</router-link>
                </li>
                <li>
                  <router-link to="/storemovments">تحويل بضاعه بين مخازن الفرع</router-link>
                </li>
                <li>
                  <router-link to="/transferbranchmasters">تحويل بضاعة لفرع آخر</router-link>
                </li>
                <li>
                  <router-link to="/receiptbranchtransfer">إستلام بضاعة من فرع آخر</router-link>
                </li>
                <li>
                  <router-link to="/manufacturing">تصنيع</router-link>
                </li>
                <li>
                  <router-link to="/salesreturns">مرتجعات مبيعات</router-link>
                </li>
                <li>
                  <router-link to="/stocktaking">جرد المخازن</router-link>
                </li>
                <li>
                  <router-link to="/stockmovementrep">حركة المخزن</router-link>
                </li>
                <li>
                  <router-link to="/itemcard">كارتة صنف</router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.account_department_show">
              <a href="#" @click="changeMenu(6)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة الحسابات <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu06 ? 'in' : ''" >
                <li v-show="$per.value.getTreasury">
                  <router-link to="/treasuries">الخزن </router-link>
                </li>
                <li v-show="$per.value.getTreasuryMovment">
                  <router-link to="/treasurymovments"> تحويل نقدية </router-link>
                </li>
                <li v-show="$per.value.getRecordRevenueExpenses">
                  <router-link to="/recordrevenueexpenses"> تسجيل الايرادات والمصروفات </router-link>
                </li>
                <li>
                  <router-link to="/dailyaccounts">اليومية</router-link>
                </li>
                <li>
                  <router-link to="/treasuryreport"> تقرير الخزينة </router-link>
                </li>
                <li  :class="{disabled:built}">
                  <router-link to="/morris"> تقرير المصروفات </router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.emp_department_show">
              <a href="#" @click="changeMenu(7)"><i class="fa fa-bar-chart-o fa-fw"></i> إدارة الأفراد <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu07 ? 'in' : ''" >
                <li v-show="$per.value.getEmployee">
                  <router-link to="/employees"> بيانات الموظفين </router-link>
                </li>
                <li v-show="$per.value.getEmpItineraries">
                  <router-link to="/empitineraries"> خطوط الموظفين </router-link>
                </li>
                <li v-show="$per.value.getSalaryMovement">
                  <router-link to="/salarymovement"> الحوافز والخصومات </router-link>
                </li>
                <li v-show="$per.value.getAdvance">
                  <router-link to="/advances"> سلف </router-link>
                </li>
                <li v-show="$per.value.getPayroll">
                  <router-link to="/payroll"> كشف الرواتب </router-link>
                </li>
                <li v-show="$per.value.getPayroll">
                  <router-link to="/tellerUsersReport">تقرير موظفى التيلر </router-link>
                </li>
                <li v-show="$per.value.getPayroll">
                  <router-link to="/tecReport">تقرير فنى/مفوض</router-link>
                </li>
              </ul>
            </li>
            <li v-show="this.$per.value.Settings_department_show">
              <a href="#" @click="changeMenu(8)"><i class="fa fa-bar-chart-o fa-fw"></i> الإعدادات <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu08 ? 'in' : ''" >
                <li v-show="$per.value.getDataSessions">
                  <router-link to="/sessions"> إدارة الجلسات </router-link>
                </li>
                <li v-show="$per.value.getDataSessions">
                  <router-link to="/usersactivity"> حركة المستخدمين </router-link>
                </li>
              </ul>
            </li>
            <li v-show="$per.value.getEmployee">
              <a href="#" @click="changeMenu(9)"><i class="fa fa-bar-chart-o fa-fw"></i> تقارير <span class="fa arrow"></span></a>
              <ul class="nav nav-second-level collapse " :class="isMenu09 ? 'in' : ''" >
                <li>
                  <router-link to="/rep01"> اقساط مستهدفة </router-link>
                </li>
                <li>
                  <router-link to="/rep02"> الشمع المطلوب </router-link>
                </li>
                <li>
                  <router-link to="/rep03"> الشمع المستهدف </router-link>
                </li>
                <li>
                  <router-link to="/branchperformance"> تقرير اداء الفروع </router-link>
                </li>
                <li>
                  <router-link to="/allusersCallLog"> تقرير سجل المكالمات </router-link>
                </li>
                <li>
                  <router-link to="/customrreviewrep"> تقرير بمراجعة العملاء </router-link>
                </li>
                <li>
                  <router-link to="/getbranchreceiptsstatus">تقرير بحالات ايصالات الفرع </router-link>
                </li>
                <li v-show="this.isdba == 0">
                  <router-link to="/customeractivity"> حركة عميل </router-link>
                </li>
                <li>
                  <router-link to="/incomingstore"> صادر المخزن </router-link>
                </li>
                <li v-show="this.isdba == 0">
                  <router-link to="/mobilereadactive">Qr Code </router-link>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="preformLogout"> <i class="fa fa-sign-out fa-fw" ></i>  خروج </a>
            </li>
            <!-- /Tbaark System Menu End -->
            <!-- /Tbaark System Menu End -->
          </ul>
        </div>
        <!-- /.sidebar-collapse -->
      </div>
      <!-- /.navbar-static-side -->
    </nav>

    <router-view/>
    <!-- SearchAlterReceiptModal Modal -->
    <div class='modal fade' id='SearchAlterReceipt' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>البحث عن ايصال</h4>
          </div>
          <SearchAlterReceipt ref="SearchAlterReceipt"> </SearchAlterReceipt>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /SearchAlterReceiptModal modal -->
    <!-- ================ Contracts Modal Begin ======================================== -->
    <CustomerDetails ref="CustomerDetails"> </CustomerDetails>
  <!-- ================  /.modal-content ======================================== -->
  </div>
</template>
<style>
.sidebarcustom {
    overflow-y: scroll;
    top: 100px;
    bottom: 0;
    position: fixed;

    /* إخفاء السكرول في Firefox */
    scrollbar-width: none;

    /* إخفاء السكرول في IE و Edge القديم */
    -ms-overflow-style: none;
}

/* إخفاء السكرول في Chrome و Safari */
.sidebarcustom::-webkit-scrollbar {
    display: none;
}
  .avatarLarg {
    vertical-align: middle;
    width: 75px;
    height: 75px;
    border-radius: 50%;
    padding: 2px;
    border: 3px solid #ddd;
  }
  .avatar {
    vertical-align: middle;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 1px;
    border: 2px solid #ddd;
  }
</style>
<script>
import axios from 'axios'
import QrCodeImage from '@/assets/qr-code.png'
import {version} from '../../package'
import SearchAlterReceipt from './Sales/SearchAlterReceipt'
import CustomerDetails from '@/components/Sales/Customers/CustomerDetails'
export default {
  components: {
    SearchAlterReceipt,
    CustomerDetails
  },
  name: 'Home',
  data () {
    return {
      notifications: [],
      // image: 'https://www.plfilters.com/style-img/eidstyle.png',
      // imageSidebar: 'https://www.plfilters.com/style-img/eid_ad.png',

      image: 'https://www.plfilters.com/style-img/eidstyle.png',
      imageSidebar: 'https://www.plfilters.com/style-img/eidosama.png',
      // image: 'https://www.plfilters.com/style-img/ramadanstyle.png',
      // imageSidebar: 'https://www.plfilters.com/style-img/ramadankenzy.png',
      pic: 'profile picture',
      imgURL: 'https://plfilters.com/api/system/storage/app/av-img/' + localStorage.getItem('avt_img'),
      isMenu00: false,
      isMenu01: false,
      isMenu02: false,
      isMenu03: false,
      isMenu04: false,
      isMenu05: false,
      isMenu06: false,
      isMenu07: false,
      isMenu08: false,
      isMenu09: false,
      isMenu10: false,
      isMenu11: false,
      QrCodeImage: QrCodeImage,
      appVersion: version,
      main_data: {},
      built: true,
      Auth: false,
      Remainder: 0,
      Remainder_p: 0,
      Maintenance: 0,
      Maintenance_p: 0,
      MaintenanceReq: 0,
      MaintenanceReq_p: 0,
      isAdmain: 0,
      isdba: null,
      isSaad: null,
      isTm: false
    }
  },
  created () {
    this.$per.value = JSON.parse(localStorage.getItem('Per'))
    this.getData()
    var userID = JSON.parse(localStorage.getItem('user_id'))
    if (userID === 3 || userID === 2) {
      this.isSaad = true
    }
    if (userID === 218 || userID === 2) {
      this.isTm = true
    }
    this.main_data = JSON.parse(localStorage.getItem('main_data'))
    this.isdba = JSON.parse(localStorage.getItem('dba'))
  },
  // =========================================================================
  computed: {
    unreadCount () {
      return this.notifications.filter(n => !n.read).length
    }
  },
  // =========================================================================
  mounted () {
    this.initPusher()
  },
  // =========================================================================
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    // =========================================================================
    markAsRead (id) {
      this.notifications = this.notifications.map(n =>
        n.id === id ? { ...n, read: true } : n
      )
    },
    // =========================================================================
    initPusher () {
      const pusher = new window.Pusher('187d58ce73763ac8ccfb', {
        cluster: 'eu'
      })
      const channels = JSON.parse(localStorage.getItem('notificationChannels')) || []
      if (channels.length > 0) {
        channels.forEach(ch => {
          const channel = pusher.subscribe(ch)
          // ------------------------------------------------ Event_1 -----------
          channel.bind('delay', (data) => {
            this.notifications.unshift({
              id: Date.now(),
              time: new Date().toLocaleTimeString('ar-EG', {
                hour: '2-digit',
                minute: '2-digit'
              }),
              type: 'طلب تأجيل',
              name: data.message.name,
              user: data.message.user,
              data: data.message,
              read: false
            })
          })
          // ------------------------------------------------------------------
        })
      }
    },
    // ===========================================================================
    getCustomerDelay (rec, index) {
      this.$refs.CustomerDetails.setData(rec.data.id, null)
      this.notifications.splice(index, 1)
    },
    // =========================================================================
    changeMenu (id) {
      switch (id) {
        case 0:
          this.isMenu00 = !this.isMenu00
          break
        case 1:
          this.isMenu01 = !this.isMenu01
          break
        case 2:
          this.isMenu02 = !this.isMenu02
          break
        case 3:
          this.isMenu03 = !this.isMenu03
          break
        case 4:
          this.isMenu04 = !this.isMenu04
          break
        case 5:
          this.isMenu05 = !this.isMenu05
          break
        case 6:
          this.isMenu06 = !this.isMenu06
          break
        case 7:
          this.isMenu07 = !this.isMenu07
          break
        case 8:
          this.isMenu08 = !this.isMenu08
          break
        case 9:
          this.isMenu09 = !this.isMenu09
          break
        case 10:
          this.isMenu10 = !this.isMenu10
          break
      }
      if (id > 0) {
        if (id !== 1) { this.isMenu01 = false }
        if (id !== 2) { this.isMenu02 = false }
        if (id !== 3) { this.isMenu03 = false }
        if (id !== 4) { this.isMenu04 = false }
        if (id !== 5) { this.isMenu05 = false }
        if (id !== 6) { this.isMenu06 = false }
        if (id !== 7) { this.isMenu07 = false }
        if (id !== 8) { this.isMenu08 = false }
        if (id !== 9) { this.isMenu09 = false }
        if (id !== 10) { this.isMenu10 = false }
        if (id !== 11) { this.isMenu11 = false }
      }
    },
    getData () {
      this.isLoading = true
      axios.post(this.$apiURL + 'checkAuth', {
        token: localStorage.getItem('token')
      })
        .then(res => {
          this.Auth = true
          this.isAdmain = res.data.isAdmin
          this.Remainder_p = res.data.Remainder_p
          this.Remainder = res.data.Remainder
          this.Maintenance_p = res.data.Maintenance_p
          this.Maintenance = res.data.Maintenance
          this.MaintenanceReq_p = res.data.MaintenanceReq_p
          this.MaintenanceReq = res.data.MaintenanceReq
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.isLoading = false
        })
    },
    // ===========================================================
    SearchAlterReceipt () {
      this.$refs.SearchAlterReceipt.pageLoad()
    },
    // ===========================================================
    preformLogout () {
      localStorage.removeItem('BrancheID')
      localStorage.removeItem('user_id')
      localStorage.removeItem('UID')
      localStorage.removeItem('token')
      localStorage.removeItem('main_data')
      localStorage.removeItem('Items')
      localStorage.removeItem('Branches')
      localStorage.removeItem('Gov')
      localStorage.removeItem('typeID')
      localStorage.removeItem('Per')
      this.$router.push('/Login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue